<template>
  <div class="vip-container">
 
     <div v-if="banners.length > 0" class="vip-banner-wrapper">
      <div class="embla" ref="emblaNode">
        <div class="embla__container">
          <div
            v-for="banner in banners"
            :key="banner._id"
            class="embla__slide banner-slide"
            @click="goTo(banner.url)"
          >
            <div class="banner-frame">
              <img
                v-if="banner.imageUrl"
                :src="backendUrl + banner.imageUrl"
                alt="VIP Banner"
                class="banner-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- VIP Info Cards -->
    <div class="vip-info-cards">
      <div class="vip-card" v-for="(card, index) in cards" :key="index">
        <div class="card-icon-wrapper">
          <img :src="card.icon" class="card-icon" />
        </div>
        <div class="card-content">
          <h4 class="card-title">{{ card.title }}</h4>
          <p class="card-description">{{ card.description }}</p>
        </div>
      </div>
    </div>

    <!-- VIP Level Section -->
    <div class="vip-main">
      <!-- Sidebar (Left) -->
 <div class="vip-sidebar">
  <div v-if="userVip" class="vip-sidebar-inner responsive-sidebar">
    
    <!-- SOL: BADGE -->
    <div v-if="userVip.vipBadgeImage" class="vip-badge-wrapper badge-inline">
      <img :src="backendUrl + userVip.vipBadgeImage" class="vip-badge" />
    </div>

    <!-- SAĞ: TEXT BLOK -->
    <div class="vip-text-block">
      <p class="vip-current-label">{{ $t('vip.Current VIP Level') }}</p>
      <h2 class="vip-level-name align-left">{{ userVip.levelName }}</h2>
     <div class="vip-next-xp-box" v-if="vipLevel">
  <span class="xp-highlight">{{ xpRemainingFixed }}</span>

  <span>{{ $t('vip.XP to next level') }}</span>
</div>

    </div>

    <!-- ÖDÜLLER -->
    <div class="vip-rewards-list">
      <h3 class="rewards-title"> {{ $t('vip.VIP Rewards') }}</h3>
      <div
        v-for="(reward, type) in rewards"
        :key="type"
        class="reward-item"
      >
        <div class="reward-left">
          <img :src="getIconFor(type)" class="reward-icon" />
          <span class="reward-title">{{ vipBenefits[type] }}</span>
        </div>
        <div class="reward-right">
          <button
            v-if="reward.available"
            @click="claimReward(type)"
            class="claim-btn"
          >
             {{ $t('vip.Claim') }}
          </button>
          <VipCountdown
            v-else-if="reward.nextAvailable"
            :targetTime="reward.nextAvailable"
          />
          <button v-else disabled class="locked-btn">{{ $t('vip.Locked') }}</button>
        </div>
      </div>
    </div>

  </div>
</div>


      <!-- Tabs & Level Detail (Right) -->
     <div class="vip-tab-section">
  <div class="vip-tabs-container">
    <div class="vip-tabs">
      <div
        v-for="level in vipLevels"
        :key="level._id"
        :class="['vip-tab', { active: selectedVip._id === level._id }]"
        @click="selectVip(level)"
      >
        <div class="vip-tab-content">
          <img 
            :src="backendUrl + level.vipBadgeImage" 
            alt="VIP Badge" 
            class="vip-tab-badge-large" 
          />
          <div class="vip-tab-text">
            <span class="vip-tab-name">{{ level.levelName }}</span>
           
           
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- VIP Details Section -->
  <div class="vip-details" v-if="selectedVip">
    <div class="vip-benefit-grid">
      <div 
        class="vip-benefit" 
        v-for="(label, key) in vipBenefits" 
        :key="key"
      >
        <div class="benefit-label">
          <div class="benefit-icon-wrapper">
            <img :src="getIconFor(key)" class="benefit-icon" />
          </div>
          <div class="benefit-text">
            <div class="benefit-title">{{ label }}</div>
            <div class="benefit-value">
  {{ formatVipValue(key, selectedVip[key]) }}
</div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import emblaCarousel from 'embla-carousel'
import VipCountdown from '@/components/VipCountdown.vue';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import { mapGetters, mapActions } from 'vuex';
import { useCurrency } from '@/composables/useCurrency'


export default {
  components: {
    emblaCarousel,
    VipCountdown
  },
  data() {
    return {
      banners: [],
      vipLevels: [],
      selectedVip: {},
      embla: null,
      userVip: null,
      rewards: {
  upgradeReward: {},
  dailyVipReward: {},
  weeklyVipReward: {},
  vipDayReward: {}
},
vipUsdFields: [
  'upgradeReward',
  'dailyVipReward',
  'weeklyVipReward',
  'vipDayReward'
],
formatFiat: null,
    userFiat: null,

      backendUrl: process.env.VUE_APP_BACKEND_URL,
      userXp: 0,
      vipBenefits: {
  dailyCashback: this.$t('vip.dailyCashback'),
  weeklyCashback: this.$t('vip.weeklyCashback'),
  monthlyCashback: this.$t('vip.monthlyCashback'),
  upgradeReward: this.$t('vip.upgradeReward'),
  dailyVipReward: this.$t('vip.dailyVipReward'),
  weeklyVipReward: this.$t('vip.weeklyVipReward'),
  vipDayReward: this.$t('vip.vipDayReward'),
  vipDay: this.$t('vip.vipDay'),
  withdrawLimit: this.$t('vip.withdrawLimit'),
  vipSupportInfo: this.$t('vip.vipSupportInfo')
},
      cards: [
  {
    icon: require('@/assets/img/vip/desc1.png'),
    title: this.$t('vip.cards.fastUpgrade.title'),
    description: this.$t('vip.cards.fastUpgrade.desc')
  },
  {
    icon: require('@/assets/img/vip/desc2.png'),
    title: this.$t('vip.cards.dailyRewards.title'),
    description: this.$t('vip.cards.dailyRewards.desc')
  },
  {
    icon: require('@/assets/img/vip/desc3.png'),
    title: this.$t('vip.cards.cashbackAdvantage.title'),
    description: this.$t('vip.cards.cashbackAdvantage.desc')
  },
  {
    icon: require('@/assets/img/vip/desc4.png'),
    title: this.$t('vip.cards.vipSupport.title'),
    description: this.$t('vip.cards.vipSupport.desc')
  }
],
      slickOptions: {
        arrows: true,
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000
      }
    };
  },
  created() {
  const currency = useCurrency()
  this.formatFiat = currency.formatFiat
  this.userFiat = currency.userFiat.value // 🔥 .value ŞART
},
 
  computed: {
  ...mapGetters(['authUser']),

  // ✅ Store’daki XP hesaplamaları kullan
  ...mapGetters('vip', [
    'userVip',
    'userXp',
    'vipLevel',
    'nextVipLevel',
    'vipProgress',
    'vipDisplayXp',
    'vipNextXp'
  ]),

  currencyRate() {
  const fiat = this.authUser?.user?.currency?.fiatCurrency || 'USD'
  const rates = this.$store.state.general?.generalSettings?.exchangeRates

  if (!rates) return 1
  return rates[fiat] || 1
},

userFiatComputed() {
  return this.authUser?.user?.currency?.fiatCurrency || 'USD'
},

   xpRemainingFixed() {
    return Number(this.xpRemaining).toFixed(2)
  },

  // ✅ Eğer bu sayfada da özel gösterim yapmak istersek
  progressPercent() {
    return this.vipProgress; // Store’dan gelen % değer
  },
  progressDisplay() {
    return this.vipDisplayXp; // "222 / 300"
  },
  xpRemaining() {
    return this.vipNextXp; // kalan XP
  }
},

  mounted() {
    
  this.fetchVipBanners();
  this.fetchUserLevel();     
  this.fetchVipLevels();   
  this.fetchRewards();   
  this.$nextTick(() => {
      if (this.$refs.emblaNode) {
        this.embla = emblaCarousel(this.$refs.emblaNode, {
          loop: true,
          speed: 10,
          align: 'start'
        })

        // Otomatik scroll
        setInterval(() => {
          if (this.embla) this.embla.scrollNext()
        }, 4000)
      }
    })
  },

    beforeUnmount() {
    this.embla?.destroy()
  },

  methods: {
    async fetchVipBanners() {
      try {
        const res = await axios.get('public/banners/vip');
        this.banners = res.data || [];
      } catch (err) {
        console.error('VIP bannerlar alınamadı:', err);
      }
    },

    getFiatValue(usdAmount) {
  return `${this.formatFiat(usdAmount)}  `
},
    
  formatVipValue(key, value) {
  if (value == null) return '-'

  // ✅ USD ödüller
  if (this.vipUsdFields.includes(key)) {
    return this.getFiatValue(value)
  }

  // ✅ Cashback alanları (%)
  if (key.includes('Cashback')) {
    return `${value}%`
  }

  // ✅ VIP Day gibi numeric ama para olmayan
  if (typeof value === 'number') {
    return value
  }

  return value
},
     goTo(url) {
      if (url) window.open(url, '_blank')
    },
    async fetchVipLevels() {
  try {
    const res = await axios.get('/vip/levels');
    this.vipLevels = res.data.levels || [];   // ✅ levels içinden alıyoruz
    if (this.vipLevels.length > 0) {
      this.selectedVip = this.vipLevels[0];
    }
  } catch (err) {
    console.error('VIP seviyeleri alınamadı:', err);
    this.vipLevels = []; // fallback
  }
},


    async fetchRewards() {
  try {
    const userId = this.authUser?.user?._id;
    if (!userId) return;

    const res = await axios.get(`/vip/rewards/${userId}`);
    this.rewards = res.data.rewards;
  } catch (err) {
    console.error('Ödüller alınamadı:', err);
  }
},

async claimReward(type) {
  try {
    const res = await axios.post('/vip/claim-reward', { type });

    if (res.data.success) {
      const amount = res.data.amount;
      const currency = this.authUser.user?.currency?.fiatCurrency || 'USD';

      // ✅ Çok dilli notification
      this.$store.dispatch('notificationShow', {
        type: 'success',
        message: this.$t('notifications.rewardSuccess', { amount, currency })
      });

      this.$store.commit('auth_update_user', {
        ...this.authUser.user,
        balance: res.data.newBalance
      });

      await this.fetchRewards();
      await this.fetchUserLevel();
    } else {
      this.$store.dispatch('notificationShow', {
        type: 'warning',
        message: this.$t('notifications.rewardError')
      });
    }
  } catch (err) {
    const msg = err.response?.data?.message || this.$t('notifications.rewardServerError');
    this.$store.dispatch('notificationShow', {
      type: 'error',
      message: msg
    });
  }
},






async fetchUserLevel() {
  try {
    if (!this.authUser || !this.authUser.user || !this.authUser.user._id) {
      console.warn('authUser.user henüz hazır değil');
      return;
    }

    const userId = this.authUser.user._id;
  

    const res = await axios.get(`/vip/user-level/${userId}`);


    this.userXp = res.data.userStats.xp;
    this.userVip = res.data.userVip;
    this.selectedVip = res.data.currentLevel;
  } catch (err) {
    console.error('Kullanıcı seviyesi alınamadı:', err);
  }
}
,




   getTabXp(level) {
    const userXp = this.userXp || 0;

    // Mevcut level → bir sonraki level için kalan XP
    if (this.userVip && level.level === this.userVip.level) {
      const next = this.vipLevels.find(l => l.level === level.level + 1);
      if (!next) return this.$t('vip.maxLevel'); // max level ise
      const remaining = Math.max(next.requiredXp - userXp, 0);
      return `${remaining} XP ${this.$t('vip.remaining')}`;
    }

    // Geçmiş level’ler → hep dolu
    if (this.userVip && level.level < this.userVip.level) {
      return `0 XP ${this.$t('vip.remaining')}`;
    }

    // Gelecek level → o seviyeye ulaşmak için kalan XP
    if (this.userVip && level.level > this.userVip.level) {
      const remaining = Math.max(level.requiredXp - userXp, 0);
      return `${remaining} XP ${this.$t('vip.remaining')}`;
    }

    return `0 XP ${this.$t('vip.remaining')}`;
  },
    selectVip(level) {
      this.selectedVip = level;
    },
    goTo(url) {
      if (url) window.open(url, '_blank');
    },
   getIconFor(key) {
  try {
    return require(`@/assets/img/vip/${key}.png`);
  } catch (e) {
    return require('@/assets/img/vip/vipSupportInfo.svg'); // fallback
  }
}

  }
};
</script>

<style scoped>
/* Genel Stiller */
.vip-container {

  margin: 0 auto;
   
  
  color: #fff;
}

/* Banner Slider */
.vip-banner-wrapper {
  margin-bottom: 30px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
}

.embla {
  overflow: hidden;
  width: 100%;
}
.embla__container {
  display: flex;
}
.embla__slide {
  flex: 0 0 100%;
  min-width: 0;
}
.banner-slide {
  cursor: pointer;
  transition: transform 0.3s ease;
}



.banner-frame {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.banner-image {
  width: 100%;
  height: auto;
   
  display: block;
  transition: transform 0.5s ease;
}



/* Bilgi Kartları */
.vip-info-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.vip-card {
  background: var(--background);
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  border: 2px solid var(--outline) !important;
  z-index: 1;
}



.card-icon-wrapper {
  width: 60px;
  height: 60px;
  
 
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  flex-shrink: 0;
}

.card-icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.card-content {
  flex: 1;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 8px;
  color: #ffea2f;
  letter-spacing: 0.5px;
}

.card-description {
  font-size: 14px;
    color: var(--text-color);
    margin: 0;
    line-height: 1.5;
    font-weight: bold;
}

/* Ana İçerik */
.vip-main {
  display: flex;
  gap: 25px;
  margin-top: 25px;
}

/* Sidebar */
.vip-sidebar {
  width: 300px;
  background: var(--background);
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.vip-sidebar::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 100px;
  background: radial-gradient(circle, rgb(130 0 255 / 10%) 0%, transparent 70%);
}


.align-left {
  text-align: left;
}

.vip-current-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 4px;
  margin-left: 4px;
}

.vip-next-xp-box {
     display: inline-flex
;
    align-items: center;
    gap: 8px;
    background: var(--background2);
    border-radius: 8px;
    padding: 4px 10px;
    font-size: 13px;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 15px;
    height: 30px;
}

.xp-highlight {
      background: var(--active-button);
    color: #fff;
    font-weight: bold;
    border-radius: 6px;
    padding: 2px 8px;
    font-size: 13px;
    margin-left: -10px;
    padding-top: 7px;
    padding-bottom: 7px;
}

.vip-badge-wrapper {
  text-align: center;
  margin-bottom: 20px;
}

.vip-badge {
  width: 120px;
  height: 120px;
  object-fit: contain;
  filter: drop-shadow(0 0 10px rgba(55, 24, 112, 0.5));
  transition: transform 0.3s ease;
}



.vip-level-name {

  font-size: 24px;
  font-weight: 700;
  color: #ffea2f;
  margin-bottom: 15px;
  text-shadow: 0 0 10px rgba(0, 255, 194, 0.5);
  letter-spacing: 1px;
}

.vip-xp-info {
  text-align: center;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 15px;
}

.vip-progress-container {
  margin-top: 25px;
}

.progress-bar {
  height: 8px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 5px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #ffea2f, #00aa6d);
  border-radius: 4px;
  position: relative;
  transition: width 0.5s ease;
}

.progress-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, 
              rgba(255,255,255,0.3) 0%, 
              rgba(255,255,255,0) 100%);
}

.progress-labels {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

/* Tab Bölümü */
.vip-tab-section {
  flex: 1;
  background: var(--background);
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  
  overflow: hidden;
  z-index: 1;
  position: relative;
}


.vip-tabs-container {
  padding: 20px;
  background: rgba(0, 0, 0, 0.2);
 
}

.vip-tabs {
  display: flex;
  gap: 15px;
  overflow-x: auto;
  padding-bottom: 10px;
}

.vip-tabs::-webkit-scrollbar {
  height: 6px;
}

.vip-tabs::-webkit-scrollbar-thumb {
  background:var(--background2);
  border-radius: 3px;
}

.vip-tab {
  min-width: 200px;
  background: var(--background2);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid transparent;
  flex-shrink: 0;
}



.vip-tab.active {
  background: var(--active-button);
 
  
}

.vip-tab-content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
}

.vip-tab-badge-large {
  width: 40px;
  height: 40px;
  object-fit: contain;
  filter: drop-shadow(0 0 5px rgba(0, 255, 194, 0.3));
}

.vip-tab-text {
  display: flex;
  flex-direction: column;
}

.vip-tab-name {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.vip-tab-xp {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}

/* VIP Detayları */
.vip-details {
  padding: 25px;
}

.vip-header-wrapper {
  margin-bottom: 25px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.vip-header-image {
  width: 100%;
  max-height: 150px;
  object-fit: cover;
  display: block;
}

.vip-benefit-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.vip-benefit {
  background: var(--background2);
  border: 2px solid var(--outline) !important;
  border-radius: 8px;
  padding: 15px;
  transition: all 0.3s ease;
  
}



.benefit-label {
  display: flex;
  align-items: center;
  gap: 15px;
}

.benefit-icon-wrapper {
  width: 40px;
  height: 40px;
  
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.benefit-icon {
  width: 50px;
  height: 50px;
  object-fit: contain;
}

.benefit-text {
  flex: 1;
}

.benefit-title {
  font-size: 14px;
  font-weight: 600;
  color: #ffea2f;
  margin-bottom: 5px;
}

.benefit-value {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
}


.vip-rewards-list {
  margin-top: 20px;
  width: 100%;
}

.rewards-title {
  font-size: 14px;
  margin-bottom: 10px;
  color: rgba(255, 255, 255, 0.7);
}

.reward-item {
  display: flex;
  justify-content: space-between; /* Yeni */
  align-items: center;
  gap: 20px;
  margin-top: 15px;
}

.reward-icon {
  width: 32px;
  height: 32px;
  margin-right: 10px;
}

.reward-title {
  font-size: 13px;
  color: #fff;
  font-weight: bold;
}

.claim-btn {
  padding: 4px 10px;
  font-size: 12px;
  border: none;
  border-radius: 12px;
     background: var(--buttonyellow);
    box-shadow: var(--buttonyellowbox);
    color: #fff;
        text-shadow: -1px -1px 0 var(--roo-btn-text-stroke-color, #C56A18), 1px -1px 0 var(--roo-btn-text-stroke-color, #C56A18), -1px 1px 0 var(--roo-btn-text-stroke-color, #C56A18), 1px 1px 0 var(--roo-btn-text-stroke-color, #C56A18);
    font-weight: bold;
  
  cursor: pointer;
  margin-left: 10px;
  width: 100%;
}

.reward-left {
  display: flex;
  align-items: center;
 
}

.reward-right {
  min-width: 80px;
  display: flex;
  justify-content: flex-end;
}

.locked-btn {
  padding: 4px 10px;
  font-size: 12px;
   border-radius: 12px;
     background: var(--active-button);
    color: rgb(217, 209, 244);
    
    color: #fff;
     
  color: #fff;
  cursor: not-allowed;
  font-weight: bold;
  width: 100%;
}


/* Responsive Düzenlemeler */
@media (max-width: 1200px) {
  .vip-main {
    flex-direction: column;
  }

  .vip-container {

  margin: 0 auto;
   
  padding: 20px;
  color: #fff;
}
  
  .vip-sidebar {
    width: 100%;
    margin-bottom: 20px;
  }
}

@media (max-width: 768px) {
  .vip-info-cards {
    display: none;
  }

 .responsive-sidebar {
    display: flex;
    gap: 16px;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .badge-inline {
    flex-shrink: 0;
    width: 80px;
  }

  .badge-inline .vip-badge {
    width: 80px;
    height: 80px;
  }

  .vip-text-block {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
  }

  .vip-current-label {
    margin: 0;
    font-size: 13px;
  }

  .vip-level-name {
    font-size: 18px;
    margin: 0;
  }

  .vip-next-xp-box {
    margin-top: 4px;
    font-size: 12px;
  }
  .vip-badge-wrapper {
  text-align: left;
  
  }
  
  .vip-benefit-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
    gap: 12px;
  }

  .vip-benefit {
    padding: 12px;
    text-align: center;
  }

  .benefit-label {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .benefit-icon-wrapper {
    margin-bottom: 8px;
  }

  .benefit-icon {
    width: 40px;
    height: 40px;
  }

  .benefit-title {
    font-size: 13px;
    margin-bottom: 4px;
  }

  .benefit-value {
    font-size: 14px;
  }

   .vip-tab-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 6px;
    padding: 10px;
  }

  .vip-tab-badge-large {
    width: 50px;
    height: 50px;
  }

  .vip-tab-text {
    flex-direction: column;
    align-items: center;
  }

  .vip-tab-name {
    font-size: 13px;
  }

  .vip-tab-xp {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
  }
}

@media (max-width: 576px) {
  .vip-info-cards {
    display: none;
  }
  
.responsive-sidebar {
    display: flex;
    gap: 16px;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .badge-inline {
    flex-shrink: 0;
    width: 80px;
  }

  .badge-inline .vip-badge {
    width: 80px;
    height: 80px;
  }

  .vip-text-block {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
  }

  .vip-current-label {
    margin: 0;
    font-size: 13px;
  }

  .vip-level-name {
    font-size: 18px;
    margin: 0;
  }

  .vip-next-xp-box {
    margin-top: 4px;
    font-size: 12px;
  }
  
  .vip-tab {
    min-width: 50px;
  }

  .vip-benefit-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
    gap: 12px;
  }

  .vip-benefit {
    padding: 12px;
    text-align: center;
  }

  .benefit-label {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 0;
  }

  .benefit-icon-wrapper {
    margin-bottom: 8px;
  }

  .benefit-icon {
    width: 40px;
    height: 40px;
  }

  .benefit-title {
    font-size: 13px;
    margin-bottom: 4px;
  }

  .benefit-value {
    font-size: 14px;
  }

   .vip-tab-content {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 6px;
    padding: 10px;
  }

  .vip-tab-badge-large {
    width: 50px;
    height: 50px;
  }

  .vip-tab-text {
    flex-direction: column;
    align-items: center;
  }

  .vip-tab-name {
    font-size: 13px;
  }

  .vip-tab-xp {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
  }

  .banner-image{
    height: 150px;
  }
}
</style>